import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

export default function CTAStrip({ title, subtitle }) {
    const { t } = useLang();
    return (
        <section className="relative overflow-hidden border-y border-white/10 bg-[#0E1721]">
            <div className="grain absolute inset-0 opacity-40" aria-hidden />
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 md:py-20 relative grid md:grid-cols-2 gap-10 items-center">
                <div>
                    <div className="divider-tag mb-5">{t("cta.strip_label")}</div>
                    <h2 className="font-display text-4xl md:text-5xl text-white leading-[1.05] tracking-tight">{title || t("cta.get_estimate")}</h2>
                    <p className="mt-5 text-white/65 max-w-xl">{subtitle || t("cta.get_estimate_sub")}</p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 md:justify-end">
                    <Link to="/contact" data-testid="cta-strip-quote" className="btn-primary">{t("cta.quote")}</Link>
                    <a href="tel:+33610443864" data-testid="cta-strip-call" className="btn-ghost">{t("cta.call")}</a>
                </div>
            </div>
        </section>
    );
}
